import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';

// Register necessary components for Chart.js
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const FilledLineChart = ({ dataArray, labelKey, valueKey }) => {
  const data = {
    labels: dataArray.map(item => item[labelKey]),
    datasets: [
      {
        label: 'Availability %',
        data: dataArray.map(item => parseFloat(item[valueKey])),
        fill: 'start',
        backgroundColor: 'rgba(88, 80, 236, 0.2)', // Semi-transparent fill color
        borderColor: 'rgba(88, 80, 236, 1)', // Line color
        pointBorderColor: '#fff',
        pointBackgroundColor: 'rgba(88, 80, 236, 1)',
        pointRadius: 5,
        pointHoverRadius: 7,
        pointHitRadius: 10,
        borderWidth: 2,
        tension: 0, // Smoothness of the line curve
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        title: {
          display: true,
          text: 'Balance Amount (₹)', // X-axis label
        },

        grid: {
            display: false, // Hide vertical grid lines
        },
      },
      y: {
        title: {
          display: true,
          text: 'Occurrence % (Occurred Days / Total Days)', // Y-axis label
        },

        ticks: {
          callback: function(value) {
            return `${value}%`; // Add percentage symbol
          },
        },
        beginAtZero: true,
      },
    },
    plugins: {
      legend: {
        display: false,
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const value = context.raw || 0;
            return `₹${context.label}, ${value}%`;
          },
        },
      },
    },
  };

  return (
    <div style={{ width: '100%', height: '400px' }}> {/* Adjust the chart size */}
      <Line data={data} options={options} />
    </div>
  );
};


export default FilledLineChart;
